import { __read, __spread } from "tslib";
import { getDescription, visit, } from 'graphql';
var commentsRegistry = {};
export function resetComments() {
    commentsRegistry = {};
}
export function collectComment(node) {
    var entityName = node.name.value;
    pushComment(node, entityName);
    switch (node.kind) {
        case 'EnumTypeDefinition':
            node.values.forEach(function (value) {
                pushComment(value, entityName, value.name.value);
            });
            break;
        case 'ObjectTypeDefinition':
        case 'InputObjectTypeDefinition':
        case 'InterfaceTypeDefinition':
            if (node.fields) {
                node.fields.forEach(function (field) {
                    pushComment(field, entityName, field.name.value);
                    if (isFieldDefinitionNode(field) && field.arguments) {
                        field.arguments.forEach(function (arg) {
                            pushComment(arg, entityName, field.name.value, arg.name.value);
                        });
                    }
                });
            }
            break;
    }
}
export function pushComment(node, entity, field, argument) {
    var comment = getDescription(node, { commentDescriptions: true });
    if (typeof comment !== 'string' || comment.length === 0) {
        return;
    }
    var keys = [entity];
    if (field) {
        keys.push(field);
        if (argument) {
            keys.push(argument);
        }
    }
    var path = keys.join('.');
    if (!commentsRegistry[path]) {
        commentsRegistry[path] = [];
    }
    commentsRegistry[path].push(comment);
}
export function printComment(comment) {
    return '\n# ' + comment.replace(/\n/g, '\n# ');
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/**
 * NOTE: ==> This file has been modified just to add comments to the printed AST
 * This is a temp measure, we will move to using the original non modified printer.js ASAP.
 */
// import { visit, VisitFn } from 'graphql/language/visitor';
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */
function join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function (x) { return x; }).join(separator || '') : '';
}
function addDescription(cb) {
    return function (node, _key, _parent, path, ancestors) {
        var keys = [];
        var parent = path.reduce(function (prev, key) {
            if (['fields', 'arguments', 'values'].includes(key)) {
                keys.push(prev.name.value);
            }
            return prev[key];
        }, ancestors[0]);
        var key = __spread(keys, [parent.name.value]).join('.');
        var items = [];
        if (commentsRegistry[key]) {
            items.push.apply(items, __spread(commentsRegistry[key]));
        }
        return join(__spread(items.map(printComment), [node.description, cb(node)]), '\n');
    };
}
function indent(maybeString) {
    return maybeString && "  " + maybeString.replace(/\n/g, '\n  ');
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */
function block(array) {
    return array && array.length !== 0 ? "{\n" + indent(join(array, '\n')) + "\n}" : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */
function wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || '') : '';
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */
function printBlockString(value, isDescription) {
    var escaped = value.replace(/"""/g, '\\"""');
    return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1
        ? "\"\"\"" + escaped.replace(/"$/, '"\n') + "\"\"\""
        : "\"\"\"\n" + (isDescription ? escaped : indent(escaped)) + "\n\"\"\"";
}
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
export function printWithComments(ast) {
    return visit(ast, {
        leave: {
            Name: function (node) { return node.value; },
            Variable: function (node) { return "$" + node.name; },
            // Document
            Document: function (node) {
                return node.definitions
                    .map(function (defNode) { return defNode + "\n" + (defNode[0] === '#' ? '' : '\n'); })
                    .join('')
                    .trim() + "\n";
            },
            OperationTypeDefinition: function (node) { return node.operation + ": " + node.type; },
            VariableDefinition: function (_a) {
                var variable = _a.variable, type = _a.type, defaultValue = _a.defaultValue;
                return variable + ": " + type + wrap(' = ', defaultValue);
            },
            SelectionSet: function (_a) {
                var selections = _a.selections;
                return block(selections);
            },
            Field: function (_a) {
                var alias = _a.alias, name = _a.name, args = _a.arguments, directives = _a.directives, selectionSet = _a.selectionSet;
                return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], '  ');
            },
            Argument: addDescription(function (_a) {
                var name = _a.name, value = _a.value;
                return name + ": " + value;
            }),
            // Value
            IntValue: function (_a) {
                var value = _a.value;
                return value;
            },
            FloatValue: function (_a) {
                var value = _a.value;
                return value;
            },
            StringValue: function (_a, key) {
                var value = _a.value, isBlockString = _a.block;
                return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
            },
            BooleanValue: function (_a) {
                var value = _a.value;
                return (value ? 'true' : 'false');
            },
            NullValue: function () { return 'null'; },
            EnumValue: function (_a) {
                var value = _a.value;
                return value;
            },
            ListValue: function (_a) {
                var values = _a.values;
                return "[" + join(values, ', ') + "]";
            },
            ObjectValue: function (_a) {
                var fields = _a.fields;
                return "{" + join(fields, ', ') + "}";
            },
            ObjectField: function (_a) {
                var name = _a.name, value = _a.value;
                return name + ": " + value;
            },
            // Directive
            Directive: function (_a) {
                var name = _a.name, args = _a.arguments;
                return "@" + name + wrap('(', join(args, ', '), ')');
            },
            // Type
            NamedType: function (_a) {
                var name = _a.name;
                return name;
            },
            ListType: function (_a) {
                var type = _a.type;
                return "[" + type + "]";
            },
            NonNullType: function (_a) {
                var type = _a.type;
                return type + "!";
            },
            // Type System Definitions
            SchemaDefinition: function (_a) {
                var directives = _a.directives, operationTypes = _a.operationTypes;
                return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
            },
            ScalarTypeDefinition: addDescription(function (_a) {
                var name = _a.name, directives = _a.directives;
                return join(['scalar', name, join(directives, ' ')], ' ');
            }),
            ObjectTypeDefinition: addDescription(function (_a) {
                var name = _a.name, interfaces = _a.interfaces, directives = _a.directives, fields = _a.fields;
                return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
            }),
            FieldDefinition: addDescription(function (_a) {
                var name = _a.name, args = _a.arguments, type = _a.type, directives = _a.directives;
                return name + wrap('(', join(args, ', '), ')') + ": " + type + wrap(' ', join(directives, ' '));
            }),
            InputValueDefinition: addDescription(function (_a) {
                var name = _a.name, type = _a.type, defaultValue = _a.defaultValue, directives = _a.directives;
                return join([name + ": " + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
            }),
            InterfaceTypeDefinition: addDescription(function (_a) {
                var name = _a.name, directives = _a.directives, fields = _a.fields;
                return join(['interface', name, join(directives, ' '), block(fields)], ' ');
            }),
            UnionTypeDefinition: addDescription(function (_a) {
                var name = _a.name, directives = _a.directives, types = _a.types;
                return join(['union', name, join(directives, ' '), types && types.length !== 0 ? "= " + join(types, ' | ') : ''], ' ');
            }),
            EnumTypeDefinition: addDescription(function (_a) {
                var name = _a.name, directives = _a.directives, values = _a.values;
                return join(['enum', name, join(directives, ' '), block(values)], ' ');
            }),
            EnumValueDefinition: addDescription(function (_a) {
                var name = _a.name, directives = _a.directives;
                return join([name, join(directives, ' ')], ' ');
            }),
            InputObjectTypeDefinition: addDescription(function (_a) {
                var name = _a.name, directives = _a.directives, fields = _a.fields;
                return join(['input', name, join(directives, ' '), block(fields)], ' ');
            }),
            ScalarTypeExtension: function (_a) {
                var name = _a.name, directives = _a.directives;
                return join(['extend scalar', name, join(directives, ' ')], ' ');
            },
            ObjectTypeExtension: function (_a) {
                var name = _a.name, interfaces = _a.interfaces, directives = _a.directives, fields = _a.fields;
                return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
            },
            InterfaceTypeExtension: function (_a) {
                var name = _a.name, directives = _a.directives, fields = _a.fields;
                return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
            },
            UnionTypeExtension: function (_a) {
                var name = _a.name, directives = _a.directives, types = _a.types;
                return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? "= " + join(types, ' | ') : ''], ' ');
            },
            EnumTypeExtension: function (_a) {
                var name = _a.name, directives = _a.directives, values = _a.values;
                return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
            },
            InputObjectTypeExtension: function (_a) {
                var name = _a.name, directives = _a.directives, fields = _a.fields;
                return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
            },
            DirectiveDefinition: addDescription(function (_a) {
                var name = _a.name, args = _a.arguments, locations = _a.locations;
                return "directive @" + name + wrap('(', join(args, ', '), ')') + " on " + join(locations, ' | ');
            }),
        },
    });
}
function isFieldDefinitionNode(node) {
    return node.kind === 'FieldDefinition';
}
//# sourceMappingURL=comments.js.map